import { Palette } from '@mui/material/styles';
import { adjustLineHeight, getTypographyVariants } from './typography';
import { FontSize } from '@store/types/UserStoreSlice.type';

export const MuiMenuItem = ({ palette }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      height: '32px',
      fontFamily: getTypographyVariants(palette.fontSize).root.fontFamily,
      fontSize: getTypographyVariants(palette.fontSize).bodySmall.fontSize,
      lineHeight: getTypographyVariants(palette.fontSize).bodySmall.lineHeight,
      fontWeight: getTypographyVariants(palette.fontSize).bodySmall.fontWeight,

      ':focus':
        palette.theme === 'lio'
          ? {
              backgroundColor: palette.border.default,
            }
          : {},

      '& .MuiListItemText-root .MuiListItemText-primary': {
        fontFamily: getTypographyVariants(palette.fontSize).root.fontFamily,
        fontSize: getTypographyVariants(palette.fontSize).bodySmall.fontSize,
        lineHeight: getTypographyVariants(palette.fontSize).bodySmall.lineHeight,
        fontWeight: getTypographyVariants(palette.fontSize).bodySmall.fontWeight,
      },
      '& .MuiListItemIcon-root > svg': {
        height: '18px',
      },
      '& label.MuiFormControlLabel-root > span': {
        fontSize: getTypographyVariants(palette.fontSize).bodySmall.fontSize,
      },
      '& label.MuiFormControlLabel-root > span > svg': {
        height: `${adjustLineHeight(22, palette.fontSize)}px`,
      },

      '&.MuiMenuItem-root': {
        color: palette.theme === 'lio' ? 'initial' : palette.text?.main,
      },
    },
  },
});
